module.exports = __webpack_public_path__ + "static/media/g2.a159d0d5.png";